const objFromArray = (arr: any[], key = 'external_chat_id'): {} => arr.reduce((
  accumulator,
  current
) => {
  accumulator[current[key] ?? current.id] = current;
  return accumulator;
}, {});

export default objFromArray;
